import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store'

import Articles from './containers/Articles.vue'
import Article from './containers/Article.vue'
import Ranking from './containers/Ranking.vue'
import Events from './containers/Events.vue'
import Matches from './containers/Matches.vue'
import Match from './containers/Match.vue'
import Team from './containers/Team.vue'
import Login from './containers/Login.vue'
import Register from './containers/Register.vue'
import DashboardPage from './containers/Home.vue'
import NewArticle from './containers/NewArticle.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Articles },
  { path: '/article/:id', component: Article },
  { path: '/ranking', component: Ranking },
  { path: '/matches', component: Matches },
  { path: '/match/:id', component: Match },
  { path: '/team/:id', component: Team },
  { path: '/events', component: Events },
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { 
    path: '/new-article',
    component: NewArticle,
    beforeEnter (to, from, next) {
      if (store.state.idToken) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/dashboard',
    component: DashboardPage,
    beforeEnter (to, from, next) {
      if (store.state.idToken) {
        next()
      } else {
        next('/login')
      }
    }
  }
]

export default new VueRouter({mode: 'history', routes})